import { GuidMetaDataInterface } from '@nts/std/interfaces';
import { PropertyMetaData } from './property-meta-data';

export class GuidMetaData extends PropertyMetaData implements GuidMetaDataInterface {

    protected override _type = 'Guid';

}
